import { z } from 'zod';
import { namePart } from './inputs.js';
export const onboardingRoleInput = z.object({ role: z.enum(['TUTOR', 'STUDENT']).nullable() });
// Keep date-only strings through GraphQL and the browser. UTC is used only at
// the PostgreSQL DATE boundary; round-tripping rejects rollover dates.
export const onboardingBirthDate = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .refine((value) => {
    const date = new Date(`${value}T00:00:00.000Z`);
    return (Number.isFinite(date.getTime()) &&
        date.toISOString().slice(0, 10) === value &&
        value <= new Date().toISOString().slice(0, 10) &&
        date.getUTCFullYear() >= 1900);
});
export const completeOnboardingInput = z.discriminatedUnion('role', [
    z.object({
        role: z.literal('TUTOR'),
        firstName: namePart,
        lastName: namePart,
        birthDate: z.null().optional(),
    }),
    z.object({
        role: z.literal('STUDENT'),
        firstName: namePart,
        lastName: namePart,
        birthDate: onboardingBirthDate,
    }),
]);
export const updateProfileNamesInput = z
    .object({ firstName: namePart, lastName: namePart })
    .strict();
//# sourceMappingURL=onboarding.js.map